<template>
  <validation-observer ref="dataForm">
    <b-row>
      <b-col lg="6">
        <b-form-group id="input-group-1" :label="$t('quran_programs.reading_type')" label-for="input-1">
          <validation-provider #default="{ errors }" :name="$t('quran_programs.reading_type')" vid="reading_type"
            rules="required">
            <v-select dir="rtl" v-model="newItem.reading_type" :options="readingType" :reduce="(item) => item.id"
              label="name" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group id="input-group-1" :label="$t('quran_programs.category')" label-for="input-1">
          <div class="demo-inline-spacing">
            <!--  Women - men - mixed - children.. -->
            <b-form-radio v-model="newItem.category" name="category-radios" value="women">
              {{ $t("quran_programs.women") }}
            </b-form-radio>
            <b-form-radio v-model="newItem.category" name="category-radios" value="men">
              {{ $t("quran_programs.men") }}
            </b-form-radio>
            <b-form-radio v-model="newItem.category" name="category-radios" value="mixed">
              {{ $t("quran_programs.mixed") }}
            </b-form-radio>
            <b-form-radio v-model="newItem.category" name="category-radios" value="children">
              {{ $t("quran_programs.children") }}
            </b-form-radio>
          </div>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group id="input-group-1" :label="$t('quran_programs.room_type')" label-for="input-1">
          <validation-provider #default="{ errors }" name="room_type" vid="room_type" rules="required">
            <div class="demo-inline-spacing">
              <!--  Women - men - mixed - children.. -->
              <b-form-radio v-model="newItem.room_type" name="room_type-radios" value="0">
                {{ $t("quran_programs.group") }}
              </b-form-radio>
              <b-form-radio v-model="newItem.room_type" name="room_type-radios" value="1">
                {{ $t("quran_programs.single") }}
              </b-form-radio>
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-if="newItem.room_type == 0">
        <b-form-checkbox checked="false" value="-1" unchecked-value="0" v-model="newItem.max_students" name="check-button" switch inline>
          {{ $t('quran_programs.unlimited') }} </b-form-checkbox>
      </b-col>
      <b-col lg="3" v-if="newItem.room_type == 0 && newItem.max_students != -1">
        <b-form-group id="input-group-1" :label="$t('quran_programs.max_students')" label-for="input-1">
          <b-form-input id="input-1" v-model="newItem.max_students" type="number"
            :placeholder="$t('quran_programs.max_students')" />
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col lg="4">
        <b-form-group id="input-group-1" :label="$t('quran_programs.period')" label-for="input-1">
          <validation-provider #default="{ errors }" :name="$t('quran_programs.period')"
            :vid="$t('quran_programs.period')" rules="required">
            <div class="demo-inline-spacing">
              <!--  Women - men - mixed - children.. -->
              <b-form-radio v-model="newItem.period" name="period-radios" value="5">
                5
              </b-form-radio>
              <b-form-radio v-model="newItem.period" name="period-radios" value="10">
                10
              </b-form-radio>
              <b-form-radio v-model="newItem.period" name="period-radios" value="15">
                15
              </b-form-radio>
              <b-form-radio v-model="newItem.period" name="period-radios" value="30">
               30
              </b-form-radio>
              <b-form-radio v-model="newItem.period" name="period-radios" value="60 ">
                60
              </b-form-radio>
              <b-form-radio v-model="newItem.period" name="period-radios" value="90">
                90
              </b-form-radio>
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <div class="demo-inline-spacing">
          <b-form-checkbox v-model="newItem.camera" value="1" unchecked-value="0" class="custom-control-success" name="camera-button" switch
            inline>
            {{ $t("quran_programs.camera") }}
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="demo-inline-spacing">
          <b-form-checkbox v-model="newItem.recorded" value="1" unchecked-value="0" class="custom-control-info" name="recorded-button"
            switch inline>
            {{ $t("quran_programs.recorded") }}
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="demo-inline-spacing">
          <b-form-checkbox v-model="newItem.attendance" value="1" unchecked-value="0" checked="true" name="attendance-button" switch inline>
            {{ $t("quran_programs.attendance") }}
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="demo-inline-spacing">
          <b-form-checkbox v-model="newItem.draft" value="1" unchecked-value="0" class="custom-control-dark" checked="true"
            name="draft-button" switch inline>
            {{ $t("quran_programs.draft") }}
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import QuranProgramsController from "@/Controllers/QuranProgramsController";
import ReadingTypeController from '@/Controllers/ReadingTypeController';

export default {
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      // newItem: {},
      readingType: [],
    };
  },
  async created() {
    this.readingType = await new ReadingTypeController().GetAll();
  },
  methods: {
    async returnData() {
      const isValid = await this.$refs.dataForm.validate();
      if (!isValid) {
        return { valid: false };
      }
      return { valid: true, data: this.newItem };
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>